const copiarComTextarea = (texto: string): Promise<void> =>
  new Promise((resolve, reject) => {
    const textarea = document.createElement('textarea');
    textarea.value = texto;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      if (document.execCommand('copy')) {
        resolve();
      } else {
        reject(new Error('Falha ao copiar para a área de transferência.'));
      }
    } catch (erro) {
      reject(erro);
    } finally {
      document.body.removeChild(textarea);
    }
  });

export const copiarParaAreaDeTransferencia = (texto: string): Promise<void> =>
  navigator.clipboard?.writeText
    ? navigator.clipboard.writeText(texto)
    : copiarComTextarea(texto);
